const eur = (n) => `${Math.round(n).toLocaleString("fr-FR")} €`;

export function refPrice(l) {
  const n = l.price_3m_night;
  const m = l.price_3m_month;
  if (n == null && m == null) return { base: false, month: l.monthly_price };
  return { base: true, night: n ?? m / 30, month: m ?? n * 30 };
}

export function RefPrice({ l, big = "text-2xl", testid }) {
  const p = refPrice(l);
  if (!p.base) {
    return (
      <div data-testid={testid}>
        <span className="text-xs text-[#666]">à partir de </span>
        <span className={`font-serif ${big} text-[#1A1A1A]`}>{eur(p.month)}</span>
        <span className="text-xs text-[#666]"> / mois</span>
      </div>
    );
  }
  return (
    <div data-testid={testid}>
      <span className="text-xs text-[#666]">à partir de </span>
      <span className={`font-serif ${big} text-[#1A1A1A]`}>{eur(p.night)}</span>
      <span className="text-xs text-[#666]"> / nuit</span>
      <div className="text-xs text-[#666] mt-0.5">soit {eur(p.month)} / mois · base séjour de 3 mois</div>
    </div>
  );
}
